import type { IGetCustomerCouponsQuery } from "./CodegenTypes";

export type CartCoupon = IGetCustomerCouponsQuery["cart"]["applied_coupons"][number];
